"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CasePickupValidateDto = void 0;
const case_pickup_contact_dto_1 = require("./case-pickup-contact.dto");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const package_dimensions_dto_1 = require("./package-dimensions.dto");
const account_address_dto_1 = require("../account-addresses/account-address.dto");
class CasePickupValidateDto {
}
__decorate([
    (0, class_validator_1.ValidateNested)({ always: true }),
    (0, class_validator_1.IsObject)(),
    (0, class_transformer_1.Type)(() => case_pickup_contact_dto_1.CasePickupContactDto),
    __metadata("design:type", case_pickup_contact_dto_1.CasePickupContactDto)
], CasePickupValidateDto.prototype, "contact", void 0);
__decorate([
    (0, class_validator_1.ValidateIf)((body) => body === null || body === void 0 ? void 0 : body.address),
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => account_address_dto_1.AccountAddressDto),
    __metadata("design:type", account_address_dto_1.AccountAddressDto)
], CasePickupValidateDto.prototype, "address", void 0);
__decorate([
    (0, class_validator_1.MaxLength)(1000),
    __metadata("design:type", String)
], CasePickupValidateDto.prototype, "addressNotes", void 0);
__decorate([
    (0, class_validator_1.MaxLength)(255),
    __metadata("design:type", String)
], CasePickupValidateDto.prototype, "customerReference", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], CasePickupValidateDto.prototype, "restrictedAccess", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], CasePickupValidateDto.prototype, "tailLiftRequired", void 0);
__decorate([
    (0, class_validator_1.IsDateString)(),
    __metadata("design:type", Date)
], CasePickupValidateDto.prototype, "pickupDate", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(100000),
    __metadata("design:type", Number)
], CasePickupValidateDto.prototype, "totalPackageWeight", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(100000),
    __metadata("design:type", Number)
], CasePickupValidateDto.prototype, "singlePackageWeight", void 0);
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.MaxLength)(10),
    __metadata("design:type", String)
], CasePickupValidateDto.prototype, "weightUnit", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => package_dimensions_dto_1.PackageDimensions),
    __metadata("design:type", package_dimensions_dto_1.PackageDimensions)
], CasePickupValidateDto.prototype, "dimensions", void 0);
exports.CasePickupValidateDto = CasePickupValidateDto;
//# sourceMappingURL=case-pickup-validate.dto.js.map